import {
	Slider as ASlider,
	type SliderProps,
	SliderThumb,
	SliderTrack,
} from "react-aria-components";

export const Slider = (props: SliderProps) => {
	return (
		<ASlider className="w-full" {...props}>
			<SliderTrack className="relative h-8 w-full">
				{({ state }) => (
					<>
						<div className="bg-text-disabled absolute top-1/2 h-1 w-full -translate-y-1/2 rounded-full" />
						<div
							className="bg-interactive-primary absolute top-1/2 h-1 -translate-y-1/2 rounded-full"
							style={{
								width: `${state.getThumbPercent(0) * 100}%`,
							}}
						/>
						<SliderThumb className="bg-interactive-primary top-1/2 size-8 rounded-full" />
					</>
				)}
			</SliderTrack>
		</ASlider>
	);
};
